export type QueryParams = {
  limit: string | number
  page?: string | number
}

export class Pagination<T = unknown> {
  items: T[]

  total: number

  limit: number

  page: number

  constructor(items: T[], total: number, limit: number, page: number) {
    this.items = items;
    this.total = total;
    this.limit = limit;
    this.page = page;

    // Only clamp when the total is known (> 0). A total of 0 typically means the
    // caller has not fetched data yet and is using Pagination to derive the
    // offset for the initial request; clamping in that case would silently
    // load page 1 while the URL/paginator says page N.
    if (this.total > 0 && this.total < this.offset) {
      this.page = 1;
    }
  }

  static fromQueryParams<T = unknown>(items: T[], total: number, params: QueryParams): Pagination<T> {
    return new Pagination(
      items,
      total,
      Number(params.limit),
      Number(params.page),
    );
  }

  get offset(): number {
    return (this.page - 1) * this.limit;
  }

  getPageFromOffset(offset: number): number {
    return (offset / this.limit) + 1;
  }

  getPage(): number {
    return this.page;
  }

  getLimit(): number {
    return this.limit;
  }

  getItems(): T[] {
    return this.items.slice(this.offset, this.offset + this.limit);
  }
}
